<div id="dspace-a2a" [class.d-none]="(showOnCurrentRoute$ | async) !== true" data-a2a-scroll-show="0,60"
  class="a2a_kit a2a_kit_size_32 a2a_floating_style a2a_default_style" [attr.data-a2a-title]="title" [attr.data-a2a-url]="url">
  @for (button of buttonList; track button) {
    <a [class]="'a2a_button_' + button" [class.a2a_counter]="showCounters && button !== 'facebook'"></a>
  }
  @if (showPlusButton) {
    <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
  }
</div>
